export const INITIAL_DATA_PO_FIX = {
  partName: null,
  partCode: null,
  currentStock: null,
  poFixQtyLastMonth: null,
  totalSalesLastYear: null,
  salesDayYear: null,
  salesMtd: null,
  salesDayMtd: null,
  salesProjectionMtd: null,
  currentStockTwoMonthsLater: null,
  salesProjectionTwoMonthsLater: null,
  stockDays: null,
  acuanStock: null,
  delta: null,
  qtyRecommendation: null,
  qtyPoReal: null,
  isSaved: false,
};

export const INITIAL_DATA_PO_TENT = {
  partName: null,
  partCode: null,
  remainingStockAfter: null,
  salesTarget: null,
  salesDay: null,
  remainingStock: null,
  stockDays: null,
  delta: null,
  potentativeRecommendation: null,
  potentativeReal: null,
  isSaved: false,
};

export const DDL_RANKING = [
  { label: 10, value: 10 },
  { label: 20, value: 20 },
  { label: 30, value: 30 },
  { label: 40, value: 40 },
  { label: 50, value: 50 },
];
